export enum Scenes {
  Splash = 'Splash',
  Intro = 'Intro',
  WhoLivesQuestion = 'WhoLivesQuestion',
  SentenceVictim = 'SentenceVictim',
  DecisionStats = 'DecisionStats',
  Verdict = 'Verdict',
}

/** Kills per run before the verdict card. */
export const RUN_LENGTH = 10

/** Every Nth kill inside a run gets a "you have a type" line. */
export const TYPE_LINE_EVERY = 5

/** Share of rounds (after the first) that use a curated mirror matchup. */
export const MATCHUP_ROUND_CHANCE = 0.3
